import React from 'react';
import { Col, Row, Typography } from 'antd';
import { Colors, FontSize, FontWeight } from '@common/tokens';
import { DisputeReviewFragmentType } from '@pay-bill/graphql';
import {
  DocumentPreviewModalDeprecatedProvider,
  FileUploaderItem,
  TimeWithTimeZone,
  useDocumentPreviewModalDeprecated,
} from '@common/components';

const { Text } = Typography;

export const DisputeLastComment = ({
  comment,
}: {
  comment: NonNullable<DisputeReviewFragmentType['lastComment']>;
}) => {
  const { handleOpen } = useDocumentPreviewModalDeprecated();

  return (
    <>
      <Row>
        <Col span={24}>
          <Text type="secondary">Latest Comment</Text>
        </Col>
        <Col>
          <div className="comment-section">
            <p className="comment-content">{comment.contentAsText}</p>
            {comment.files.length > 0 && (
              <div className="comment-attachments">
                <DocumentPreviewModalDeprecatedProvider>
                  {comment.files.map((file) => (
                    <FileUploaderItem
                      color="elmDarkest"
                      iconKind="solid"
                      key={file.id}
                      onClick={() =>
                        handleOpen({
                          kind: 'uploadedFile',
                          data: file,
                        })
                      }
                      fileName={file.filename}
                      showDelete={false}
                    />
                  ))}
                </DocumentPreviewModalDeprecatedProvider>
              </div>
            )}
          </div>
          <p className="comment-details">
            {comment.author.entity.name}
            {', '}
            {comment.author.name}
            {', '}
            <TimeWithTimeZone date={comment.createdAt} variant="long_format" />
          </p>
        </Col>
      </Row>
      <style jsx>
        {`
          span.dispute-label {
            font-weight: ${FontWeight.bold};
          }
          div.comment-section {
            background-color: ${Colors.meadowHyperLight};
            margin-top: 4px;
            padding: 8px;
            width: fit-content;
            max-width: 100%;
          }
          p.comment-content {
            margin: 0;
          }
          div.comment-attachments {
            margin-top: 4px;
          }
          p.comment-details {
            color: ${Colors.midnightLighter};
            font-size: ${FontSize.xs};
            margin-bottom: 0;
            margin-top: 4px;
          }
        `}
      </style>
    </>
  );
};
